import Tabs from "@/components/Tabs";
import { Path } from "@/router";
import { useParams } from "react-router-dom";
import { useCanViewBeneficiariesBool } from "@/hooks/useCapabilities";
import { useShowPersonGrpBenefitsTab } from "./_utils";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showGrpTab = useShowPersonGrpBenefitsTab();

  if (!pgaId) return null;

  const tabItems = [
    canViewBeneficiaries ? { label: "Beneficiaries", link: `/people/${pgaId}/benefits/beneficiaries` as Path } : null,
    showGrpTab ? { label: "GRP", link: `/people/${pgaId}/benefits/grp` as Path } : null
  ].filter(Boolean) as { label: string; link: Path }[];

  return (
    <>
      <Tabs showWhenSingle tabItems={tabItems} />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
